import useHttp from 'helpers/HttpMethods';
import { AssetCustom } from 'types/AssetTypes';

const http = useHttp();
abstract class CustomerAssetsService {
  static async list(
    customerId: number,
    searchTerm: string
  ): Promise<AssetCustom[] | Response> {
    return await http.get(`/customers/${customerId}/assets?${searchTerm}`);
  }
}

export default CustomerAssetsService;
